import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {Role} from "../../../roles/Role";
import {SchedulePagePublic} from "../../../../../pages/Lk/OperatorsOnly/Schedule/SchedulePagePublic";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const SchedulePublicRouteTitleMessage = defineMessage({
  id: "schedulePublicRoute.title",
  defaultMessage: "Public Schedule",
})

export const schedulePublic: RouteDescriptor<Route.schedulePublic> = {
  route: Route.schedulePublic,
  render: SchedulePagePublic,
  title: SchedulePublicRouteTitleMessage,
  path: '/lk/schedule-public',
  allowRoles: [
    Role.freighterAdmin,
    Role.freighterServiceManager,
    Role.freighterClientManager,
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
  group: PageGroups.FLEET,
  groupTitle: PageGroupMessages.fleet,
}

